module.exports = __webpack_public_path__ + "img/tratamiento_outline_green.425d8aad.svg";